import React from 'react';
import { Popover as HLPopover } from '@headlessui/react';
import usePopoverContext from './usePopoverContext';
import clsx from 'clsx';

interface Props {
  children?: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function PopoverSpan(props: Props) {
  const { refs } = usePopoverContext();
  // si tu mets div à la place de Fragment tu as safari qui te style le wrapper ...
  return (
    <HLPopover.Button
      aria-label={props['aria-label']}
      as="div"
      className={clsx(props.className)}
      ref={refs.setReference}
      onClick={e => {
        const target = e.target as HTMLElement;
        if (props.onClick && target.dataset?.triggerType !== 'programmatic') {
          props.onClick(e);
        }
      }}
    >
      {props.children}
    </HLPopover.Button>
  );
}
